define.alias("shared/components/shared/ui/cluster-switcher", "settings/components/shared/ui/cluster-switcher");